export const editConfig = (input) => {
    return {
        hostname: input.hostname,
        httpPort: input.httpPort,
        httpsPort: input.httpsPort
    }
}